import "./new-location.scss";

import HeaderContent from "@shared/ui/header-content/header-content";
import { Button } from "primereact/button";
import { FormProvider } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";

import FormLocation from "../form-location/form-location";
import { useNewLocation } from "./new-location.hook";

export function NewLocation() {
  const {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  } = useNewLocation();

  return (
    <div id="NewLocation" className="location">
      <HeaderContent
        title={<h1>New Destination</h1>}
        backIcon={<FaChevronLeft />}
        onBack={() => navigate("../")}
      >
        <Button
          className="w-full block"
          label="Save"
          disabled={isCreating}
          onClick={handleSubmit(handleValidate, handleValidateError)}
        ></Button>
      </HeaderContent>

      <div className="p-7">
        <FormProvider {...formMethod}>
          <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4">
            <FormLocation />
          </section>
        </FormProvider>
      </div>
    </div>
  );
}

export default NewLocation;
